import {initializeApp} from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyC50e5UW-tJIyeONgoqssA8sP6UF0pRsi0",
    authDomain: "mathem-org.firebaseapp.com",
    databaseURL: "https://mathem-org-default-rtdb.firebaseio.com",
    projectId: "mathem-org",
    storageBucket: "mathem-org.firebasestorage.app",
    messagingSenderId: "184288288824",
    appId: "1:184288288824:web:f4dfb2997dfe9de09b46cd",
    measurementId: "G-ZG2277ZBZH"
};
const app = initializeApp(firebaseConfig, "User");
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export {auth, provider};
